import { Typography } from "@mui/material";
import { useLoaderData } from "react-router-dom";
import { AccountBalance } from "@mui/icons-material";
import Navigation from "../../../../../components/navigations/medical-records/cases/detail/navigation";

import { useState } from "react";

export default () => {
  const [caseObj, setCaseObj] = useState();

  const { _case, client } = useLoaderData();
  
  return (
    <Navigation activeTab="details" _case={_case}>
      <div className="flex flex-col gap-3 justify-start align-start p-4 w-full m-5">
        <div className="flex flex-row items-start w-full">
          <div className="flex flex-col p-2 w-1/5">
            <Typography className="text-md normal-case text-gray-400 w-full text-nowrap">
              Client Name:
            </Typography>
            <Typography className="text-sm normal-case text-black p-2">
              {_case.client.name}
            </Typography>
          </div>

          <div className="p-2 flex-1">
            <Typography className="flex flex-row items-baseline">
              <span className="px-2">
                <AccountBalance />
              </span>
              {_case.lawFirmName}
            </Typography>
          </div>
        </div>
        <div className="flex flex-col p-2">
          <Typography className="text-md normal-case text-gray-400">
            Date Of Birth:
          </Typography>
          <Typography className="text-sm normal-case text-black p-2">
            {client.dateOfBirth
              ? client.dateOfBirth.toLocaleDateString()
              : "N/A"}
          </Typography>
        </div>
        <div className="flex flex-col p-2">
          <Typography className="text-md normal-case text-gray-400">
            Date of Incident:
          </Typography>
          <Typography className="text-sm normal-case text-black p-2">
            {_case.dateOfAccident.toLocaleDateString()}
          </Typography>
        </div>
      </div>
    </Navigation>
  );
};
